<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title> Personal Information </mat-panel-title>
    <mat-panel-description> </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="spinner" *ngIf="personalInfo === undefined">
    <mat-spinner mode="indeterminate"></mat-spinner>
  </div>
  <div class="expansion-content" *ngIf="personalInfo !== undefined">
    <div class="cell">
      <label>Name : </label>
      <span>{{ personalInfo.firstName }}</span>
    </div>
    <div class="cell">
      <label>Email Id : </label>
      <span>{{ personalInfo.email }}</span>
    </div>
    <div class="cell">
      <label>Phone : </label>
      <span>{{ personalInfo.phoneNumber }}</span>
    </div>
    <div class="cell">
      <label>Package : </label>
      <span>{{ personalInfo.package }}</span>
    </div>
    <div class="cell">
      <label>Amount : </label>
      <span>{{ personalInfo.packageAmnt }}</span>
    </div>
    <div class="cell">
      <label>Age : </label>
      <span>{{ personalInfo.age }}</span>
    </div>
    <div class="cell">
      <label>Marital Status : </label>
      <span>{{ personalInfo.maritalStatus }}</span>
    </div>
    <div class="cell">
      <label>Occupation : </label>
      <span>{{ personalInfo.occupation }}</span>
    </div>
    <div class="cell">
      <label>Gender: </label>
      <span>{{ personalInfo.gender }}</span>
    </div>
  </div>
</mat-expansion-panel>
